export class LocalStoreService {
    ls = window.localStorage;
    constructor() {}
    setItem(key, value) {
        const string = JSON.stringify(value);
        this.ls.setItem(key, string);
        return true;
    }

    getItem(key) {
        const value = this.ls.getItem(key);
        try {
            return JSON.parse(value);
        } catch (e) {
            return null;
        }
    }

    removeItem(key) {
        this.ls.removeItem(key);
    }

    clear() {
        this.ls.clear();
    }
}
